import store from 'store'
import actions from './actions'

const STORED_USER = () => {
  const user = store.get(`app.user`)
  // user[key] = typeof item !== 'undefined' ? item : storedUser[key]
  return user
}

const initialState = {
  ...STORED_USER({
    id: '',
    name: '',
    role: '',
    email: '',
    avatar: '',
    authorized: false,
    loading: false,
  }),
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
